import React from 'react';
import { Navigate } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react'
import { Provider } from 'react-redux';
import { store, persistor } from './store';
import { PersistGate } from 'redux-persist/integration/react';
import './index.css';
import PrivateRoute from '@Routes/PrivateRoute';
import Login from './pages/Login';
import App from './App'
import Scan from './pages/Scan'
import Home from './pages/Home'
import Setting from './pages/Setting';
import reportWebVitals from './reportWebVitals';
import {
  createHashRouter,
  RouterProvider,
} from "react-router-dom";

const router = createHashRouter([
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "",
        element: <Navigate to="/home" replace />, // 默認重定向到 home
      },
      {
        path: "home",
        element: <PrivateRoute>
                    <Home />
                  </PrivateRoute>,
      },
      {
        path: "setting",
        element: <PrivateRoute>
                  <Setting />
                </PrivateRoute>,
      },
      {
        path: "scan",
        element: <PrivateRoute>
                  <Scan />
                </PrivateRoute>,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ChakraProvider>
        <RouterProvider router={router} />
      </ChakraProvider>
    </PersistGate>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
